// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/Someya Taikai Website/Someya_Taikai_WebsiteBackground_2026_3.avif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*------------------------------------------

  COMMON/DESKTOP LAYOUT (1025px AND UP)

-------------------------------------------*/
body {
    overflow-y: hidden;
}

#root {
    height: 100vh;
    background-color: #6f44bc;
}

#siteContent {
    height: inherit;
    overflow-y: scroll;
}

#contentWrapper {
    margin: 0px 20px;
    background-color: #1c1b22;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: auto;
    background-position: top;
}

#content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: auto;
}

#scrollToTop {
	visibility: hidden;
}

#infoButton {
    margin-left: 20px;
    margin-top: 10px;
    width: 30px;
    height: 30px;
}

#infoModal {
    width: 40vw;
}
#infoModalContent {
    line-height: 25px;
    margin-bottom: 40px;
    padding: 10px;
}

#termsModal {
    max-width: 800px;
}
#termsModalContent {
    margin-bottom: 40px;
    padding: 10px;
}

#bannerWrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #2e4962;
    padding: 20px;
    border-radius: 10px;
}
#bannerTitle {
    margin-top: 10px;
    margin-bottom: 0px;
    font-size: 50px;
    font-family: Staatliches;
}
#bannerSubTitle {
    font-size: 30px;
    margin: -5px 0px;
    font-family: Staatliches;
}

#promoCarousel {
    width: 90%;
}

.carouselImg {
    border-radius: 10px;
    object-fit: cover;
}

.heroActionButton {
    background-color: #51d8f7;
    border: 2px solid #111018;
    border-radius: 8px;
    padding: 10px 20px;
    width: 250px;
    align-self: stretch;
    color: transparent!important;
}
.heroActionButton .p-button-icon {
    color: #111018;
    transition: ease-in-out 0.3s;
}
.heroActionButton:hover .p-button-icon {
    font-size: 30px;
}
.heroActionButton .p-button-label.p-c {
    color: #111018;
    font-size: 18px;
    text-transform: uppercase;
}
.heroActionButton:hover {
	background-color: #90e5ff;
	border: 2px solid white;
}
.heroActionButton:focus {
	background-color: #90e5ff;
	border: 2px solid white;
}

#subscribeModalCloseButton {
    float: right;
    background-color: #404046;
    color: white;
}

.modalClosed {
    position: absolute;
    top: -380px;
    right: 30px;
    opacity: 1;
    background-color: #1d181e;
    z-index: 10;
    padding: 15px 30px;
    border: solid 2px gainsboro;
    border-radius: 20px;
    transition:
        top 500ms ease-in-out,
        opacity 500ms ease-in-out;
}

.modalOpen {
    position: absolute;
    top: 20px;
    right: 30px;
    opacity: 1;
    background-color: #1d181e;
    z-index: 10;
    padding: 15px 30px;
    border: solid 2px gainsboro;
    border-radius: 20px;
    transition:
        top 500ms ease-in-out,
        opacity 500ms ease-in-out;
    margin: auto;
}

.audienceful-headline-fK3Swv {
    margin-top: 10px !important;
    margin-bottom: 20px !important;
    font-size: 20px !important;
}

.audienceful-body-fK3Swv {
    margin-bottom: 20px !important;
    font-size: 16px !important;
}

.audienceful-form-fK3Swv {
    padding: 0px 10px;
    margin-top: 0px !important;
}

.audienceful-disclaim-fK3Swv {
    padding: 5px 15px !important;
}

#taikaiTimeline {
    margin-top: 20px;
    width: 75vw;
}

.p-timeline-event-marker {
    background-color: #b088f9;
}

#taikaiTimeline .p-panel {
    box-shadow: 10px 10px 5px #131315;
}

#taikaiTimeline .p-panel .p-panel-header {
    background: rgb(35,35,38);
    background: linear-gradient(0deg, rgba(35,35,38,1) 0%, rgba(51,51,57,1) 100%);
    cursor: default;
}

#taikaiTimeline .timelineContentImage {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
    margin-top: -10px;
}
#taikaiTimeline .timelineContentImage img {
    max-width: 600px;
    border-radius: 10px;
}


#taikaiTimeline .postDate {
    display: block;
    width: 100%;
    margin-bottom: 10px;
}
#taikaiTimeline .p-panel .p-panel-content {
    background: linear-gradient(0deg, #333339 0%, #736a75);
    cursor: default;
}

.textOverImage {
    background: rgba(22, 22, 36, .8);
    padding: 10px 15px;
    border-radius: 10px;
}

.removeTopMargin {
    margin-top: 2px;
}
.floatLeft {
    float: left;
}
.floatRight {
    float: right;
}
.textAlignLeft {
    text-align: left;
}
.textAlignRight {
    text-align: right;
}
.hoverButton {
    transition: 0.2s;
}
.hoverButton:hover {
    transform: scale(1.05);
    border: solid thin white;
}

@media (max-width: 1710px) {
    #taikaiTimeline .timelineContentImage img {
        max-width: 100%;
    }
}

/*------------------------------------------

      TABLET LAYOUT (MAX-WIDTH 1024px)

-------------------------------------------*/

@media (max-width: 1024px) {

    #infoModal {
        width: 70vw;
    }

    #taikaiTimeline {
        width: 95vw;
    }

    .modalClosed {
        top: -600px;
    }

}

/*------------------------------------------

      MOBILE LAYOUT (MAX-WIDTH 700px)

-------------------------------------------*/

@media (max-width: 700px) {

    #contentWrapper {
        margin: 0 10px;
    }

    #infoButton {
        margin-top: 15px;
        margin-left: 15px;
    }

    #infoModal {
        width: 85vw;
    }

    #bannerImg {
        margin-top: -20px;
    }

    #bannerTitle {
        word-break: break-word;
        width: 100%;
        text-align: center;
    }

    #bannerSubTitle {
        word-break: break-word;
        width: 100%;
        text-align: center;
    }

    #subscribeModalButton {
        width: 90%;
    }

    .modalClosed {
        top: -700px;
        right: 15px;
    }

    .modalOpen {
        right: 15px;
    }

    #subscriptionModal {
        width: 90vw;
        padding: 0px;
    }

    #subscribeModalCloseButton {
        width: 90%;
        float: none;
        margin-left: 5%;
        margin-bottom: 20px;
    }

    #taikaiTimeline {
        width: 85vw;
        margin: auto;
    }

    #taikaiTimeline .p-timeline-event-content {
        padding: 0;
        padding-left: 10px;
    }

    #taikaiTimeline .p-timeline-event-opposite {
        flex: 0 1;
        padding: 0;
        padding-right: 10px;
    }

    #taikaiTimeline .timelineContentImage img {
        width: 100%;
    }

    .wideDivider {
        width: 90vw;
    }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;;4CAI4C;AAC5C;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,yDAAoG;IACpG,4BAA4B;IAC5B,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,wBAAwB;AAC5B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,4BAA4B;AAChC;AACA;IACI,cAAc;IACd,4BAA4B;AAChC;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;IACf,yBAAyB;AAC7B;AACA;CACC,yBAAyB;CACzB,uBAAuB;AACxB;AACA;CACC,yBAAyB;CACzB,uBAAuB;AACxB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,UAAU;IACV,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,2BAA2B;IAC3B,mBAAmB;IACnB;;iCAE6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,2BAA2B;IAC3B,mBAAmB;IACnB;;iCAE6B;IAC7B,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,6EAA6E;IAC7E,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;;AAGA;IACI,cAAc;IACd,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,sDAAsD;IACtD,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;;;;4CAI4C;;AAE5C;;IAEI;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;AAEJ;;AAEA;;;;4CAI4C;;AAE5C;;IAEI;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;QACX,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,WAAW;QACX,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,kBAAkB;IACtB;;IAEA;QACI,SAAO;QACP,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":["/*------------------------------------------\n\n  COMMON/DESKTOP LAYOUT (1025px AND UP)\n\n-------------------------------------------*/\nbody {\n    overflow-y: hidden;\n}\n\n#root {\n    height: 100vh;\n    background-color: #6f44bc;\n}\n\n#siteContent {\n    height: inherit;\n    overflow-y: scroll;\n}\n\n#contentWrapper {\n    margin: 0px 20px;\n    background-color: #1c1b22;\n    background-image: url(\"../public/Someya Taikai Website/Someya_Taikai_WebsiteBackground_2026_3.avif\");\n    background-repeat: no-repeat;\n    background-size: auto;\n    background-position: top;\n}\n\n#content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    margin: auto;\n}\n\n#scrollToTop {\n\tvisibility: hidden;\n}\n\n#infoButton {\n    margin-left: 20px;\n    margin-top: 10px;\n    width: 30px;\n    height: 30px;\n}\n\n#infoModal {\n    width: 40vw;\n}\n#infoModalContent {\n    line-height: 25px;\n    margin-bottom: 40px;\n    padding: 10px;\n}\n\n#termsModal {\n    max-width: 800px;\n}\n#termsModalContent {\n    margin-bottom: 40px;\n    padding: 10px;\n}\n\n#bannerWrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-color: #2e4962;\n    padding: 20px;\n    border-radius: 10px;\n}\n#bannerTitle {\n    margin-top: 10px;\n    margin-bottom: 0px;\n    font-size: 50px;\n    font-family: Staatliches;\n}\n#bannerSubTitle {\n    font-size: 30px;\n    margin: -5px 0px;\n    font-family: Staatliches;\n}\n\n#promoCarousel {\n    width: 90%;\n}\n\n.carouselImg {\n    border-radius: 10px;\n    object-fit: cover;\n}\n\n.heroActionButton {\n    background-color: #51d8f7;\n    border: 2px solid #111018;\n    border-radius: 8px;\n    padding: 10px 20px;\n    width: 250px;\n    align-self: stretch;\n    color: transparent!important;\n}\n.heroActionButton .p-button-icon {\n    color: #111018;\n    transition: ease-in-out 0.3s;\n}\n.heroActionButton:hover .p-button-icon {\n    font-size: 30px;\n}\n.heroActionButton .p-button-label.p-c {\n    color: #111018;\n    font-size: 18px;\n    text-transform: uppercase;\n}\n.heroActionButton:hover {\n\tbackground-color: #90e5ff;\n\tborder: 2px solid white;\n}\n.heroActionButton:focus {\n\tbackground-color: #90e5ff;\n\tborder: 2px solid white;\n}\n\n#subscribeModalCloseButton {\n    float: right;\n    background-color: #404046;\n    color: white;\n}\n\n.modalClosed {\n    position: absolute;\n    top: -380px;\n    right: 30px;\n    opacity: 1;\n    background-color: #1d181e;\n    z-index: 10;\n    padding: 15px 30px;\n    border: solid 2px gainsboro;\n    border-radius: 20px;\n    transition:\n        top 500ms ease-in-out,\n        opacity 500ms ease-in-out;\n}\n\n.modalOpen {\n    position: absolute;\n    top: 20px;\n    right: 30px;\n    opacity: 1;\n    background-color: #1d181e;\n    z-index: 10;\n    padding: 15px 30px;\n    border: solid 2px gainsboro;\n    border-radius: 20px;\n    transition:\n        top 500ms ease-in-out,\n        opacity 500ms ease-in-out;\n    margin: auto;\n}\n\n.audienceful-headline-fK3Swv {\n    margin-top: 10px !important;\n    margin-bottom: 20px !important;\n    font-size: 20px !important;\n}\n\n.audienceful-body-fK3Swv {\n    margin-bottom: 20px !important;\n    font-size: 16px !important;\n}\n\n.audienceful-form-fK3Swv {\n    padding: 0px 10px;\n    margin-top: 0px !important;\n}\n\n.audienceful-disclaim-fK3Swv {\n    padding: 5px 15px !important;\n}\n\n#taikaiTimeline {\n    margin-top: 20px;\n    width: 75vw;\n}\n\n.p-timeline-event-marker {\n    background-color: #b088f9;\n}\n\n#taikaiTimeline .p-panel {\n    box-shadow: 10px 10px 5px #131315;\n}\n\n#taikaiTimeline .p-panel .p-panel-header {\n    background: rgb(35,35,38);\n    background: linear-gradient(0deg, rgba(35,35,38,1) 0%, rgba(51,51,57,1) 100%);\n    cursor: default;\n}\n\n#taikaiTimeline .timelineContentImage {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 30px;\n    margin-top: -10px;\n}\n#taikaiTimeline .timelineContentImage img {\n    max-width: 600px;\n    border-radius: 10px;\n}\n\n\n#taikaiTimeline .postDate {\n    display: block;\n    width: 100%;\n    margin-bottom: 10px;\n}\n#taikaiTimeline .p-panel .p-panel-content {\n    background: linear-gradient(0deg, #333339 0%, #736a75);\n    cursor: default;\n}\n\n.textOverImage {\n    background: rgba(22, 22, 36, .8);\n    padding: 10px 15px;\n    border-radius: 10px;\n}\n\n.removeTopMargin {\n    margin-top: 2px;\n}\n.floatLeft {\n    float: left;\n}\n.floatRight {\n    float: right;\n}\n.textAlignLeft {\n    text-align: left;\n}\n.textAlignRight {\n    text-align: right;\n}\n.hoverButton {\n    transition: 0.2s;\n}\n.hoverButton:hover {\n    transform: scale(1.05);\n    border: solid thin white;\n}\n\n@media (max-width: 1710px) {\n    #taikaiTimeline .timelineContentImage img {\n        max-width: 100%;\n    }\n}\n\n/*------------------------------------------\n\n      TABLET LAYOUT (MAX-WIDTH 1024px)\n\n-------------------------------------------*/\n\n@media (max-width: 1024px) {\n\n    #infoModal {\n        width: 70vw;\n    }\n\n    #taikaiTimeline {\n        width: 95vw;\n    }\n\n    .modalClosed {\n        top: -600px;\n    }\n\n}\n\n/*------------------------------------------\n\n      MOBILE LAYOUT (MAX-WIDTH 700px)\n\n-------------------------------------------*/\n\n@media (max-width: 700px) {\n\n    #contentWrapper {\n        margin: 0 10px;\n    }\n\n    #infoButton {\n        margin-top: 15px;\n        margin-left: 15px;\n    }\n\n    #infoModal {\n        width: 85vw;\n    }\n\n    #bannerImg {\n        margin-top: -20px;\n    }\n\n    #bannerTitle {\n        word-break: break-word;\n        width: 100%;\n        text-align: center;\n    }\n\n    #bannerSubTitle {\n        word-break: break-word;\n        width: 100%;\n        text-align: center;\n    }\n\n    #subscribeModalButton {\n        width: 90%;\n    }\n\n    .modalClosed {\n        top: -700px;\n        right: 15px;\n    }\n\n    .modalOpen {\n        right: 15px;\n    }\n\n    #subscriptionModal {\n        width: 90vw;\n        padding: 0px;\n    }\n\n    #subscribeModalCloseButton {\n        width: 90%;\n        float: none;\n        margin-left: 5%;\n        margin-bottom: 20px;\n    }\n\n    #taikaiTimeline {\n        width: 85vw;\n        margin: auto;\n    }\n\n    #taikaiTimeline .p-timeline-event-content {\n        padding: 0;\n        padding-left: 10px;\n    }\n\n    #taikaiTimeline .p-timeline-event-opposite {\n        flex: 0;\n        padding: 0;\n        padding-right: 10px;\n    }\n\n    #taikaiTimeline .timelineContentImage img {\n        width: 100%;\n    }\n\n    .wideDivider {\n        width: 90vw;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
